// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610010204/js/" + chunkId + "." + {"44":"67f2a289","225":"dba93e86","481":"ba76c59f","486":"89329594","770":"0481c0a5"}[chunkId] + ".0.9159771045082882.chunk.js";
};